import { indexData } from '@/mocks/home';

const iconColorMap: Record<string, string> = {
  primary: 'bg-primary-500/15 text-primary-400',
  accent: 'bg-accent-500/15 text-accent-400',
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-500/15 text-primary-400 text-xs font-medium mb-3 whitespace-nowrap">
            分门别类
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
            专题合集
          </h2>
          <p className="text-foreground-500 text-sm mt-2 max-w-xl mx-auto">
            按主题分类浏览，快速找到你最关心的黑料赛道
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexData.map((item) => (
            <a
              key={item.id}
              href="#"
              className="flex items-start gap-4 p-4 md:p-5 rounded-lg bg-background-200/70 border border-background-300/50 hover:border-primary-500/30 transition-all duration-200 group cursor-pointer"
            >
              <div className={`w-11 h-11 md:w-12 md:h-12 rounded-lg flex items-center justify-center flex-shrink-0 ${iconColorMap[item.color]}`}>
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-foreground-100 font-semibold text-sm md:text-base group-hover:text-primary-400 transition-colors font-heading">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs md:text-sm mt-1 line-clamp-1">
                  {item.desc}
                </p>
              </div>
              <div className="flex-shrink-0 text-right">
                <span className="text-accent-400 font-bold text-sm md:text-base">{item.count}</span>
                <span className="text-foreground-600 text-xs block">篇</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}